// Minimal shell for fullscreen tools (no sidebar) — e.g. tearsheet viewer.
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Spinner } from '@/components/ui';
import { usePageTitle } from '@/hooks/usePageTitle';
import NotFoundPage from '@/pages/NotFoundPage';
import ForbiddenPage from '@/pages/ForbiddenPage';
import { useRouteAccessDenial } from '@/routes/routeAccess';

export default function FullscreenLayout() {
  // Per-route access (admin/role-based-access §2) — this shell hosts the pe:dataset-gated
  // tearsheet viewer, so it needs the same resolution as AppLayout. Inert until a route declares
  // `access`.
  const accessDenial = useRouteAccessDenial();
  usePageTitle({ suppress: accessDenial === 'notFound' });

  // Bare page, no shell — must match the root `path: '*'` 404 exactly (see AppLayout).
  if (accessDenial === 'notFound') return <NotFoundPage />;

  return (
    <div
      className="tearsheet-fullscreen-layout"
      data-testid="tearsheet-fullscreen-layout"
      style={{
        minHeight: '100dvh',
        height: '100dvh',
        width: '100%',
        overflow: 'hidden',
        background: '#0f172a',
      }}
    >
      <Suspense
        fallback={
          <div className="d-flex align-items-center justify-content-center h-100">
            <Spinner />
          </div>
        }
      >
        {accessDenial === 'forbidden' ? <ForbiddenPage /> : <Outlet />}
      </Suspense>
    </div>
  );
}
